import React, { Fragment, useState, useEffect } from "react";
import { ORGANIZATION_PROFILE, PUBLISH_TO_BLOCKCHAIN } from "../Routes";
import Settings from "./Settings";
import { useSelector } from "react-redux";
import validator from "shared/dist/utils/validator";
import { orgSetupRegionValidationConstraints } from "./validationConstraints";
import { isUndefined } from "lodash";
import { SNETButton, AlertBox, alertTypes } from "shared/dist/components";
import { useFinishLater } from "..";
import { useNavigateTo } from "../../../GlobalRouter/hook/NavigateTo";
import FormContentCard from "../../../Components/PageFormComponents/FormContentCard";
import FormActions from "../../../Components/PageFormComponents/FormActions";

const Region = () => {
    const navigateTo = useNavigateTo();
    const { handleFinishLater } = useFinishLater();
    const organization = useSelector((state) => state.organization);
    const { groups } = organization;
    const [isDisableContinueButton, setIsDisableContinueButton] = useState(false);
    const [alert, setAlert] = useState({});

    useEffect(() => {
        const isFormInvalid = () => {
            const invalidFields = validator(organization, orgSetupRegionValidationConstraints, {
                format: "flat",
            });
            return !isUndefined(invalidFields);
        };

        setIsDisableContinueButton(isFormInvalid());
    }, [organization]);

    const handleContinue = () => {
        navigateTo.organizationSetup({ orgUuid: organization.uuid }, PUBLISH_TO_BLOCKCHAIN.path);
    };

    const handleBack = () => {
        navigateTo.organizationSetup({ orgUuid: organization.uuid }, ORGANIZATION_PROFILE.path);
    };

    const onFinishLater = async () => {
        try {
            setAlert({});
            await handleFinishLater();
            setAlert({ type: alertTypes.SUCCESS, message: "Changes have been saved to draft" });
        } catch (error) {
            const errorMessage = "Unable to save draft. Please try later";
            setAlert({ type: alertTypes.ERROR, message: errorMessage });
        }
    };

    return (
        <Fragment>
            <FormContentCard
                title="Regional Groups Configuration"
                description={
                    <>
                        Every AI service your company publishes can be optimized for users based in
                        various regions and groups. Groups provide a mechanism of having multiple
                        instances of a service in a geographically distributed manner. Details
                        &nbsp;
                        <a
                            href="https://dev.singularitynet.io/docs/products/DecentralizedAIPlatform/PublisherPortal/text-guide/"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            here
                        </a>
                    </>
                }
            >
                {groups.map((group, index) => (
                    <Settings
                        groups={groups}
                        groupIndex={index}
                        group={group}
                        key={group.id}
                        foundInBlockchain={organization.foundInBlockchain}
                    />
                ))}
                <AlertBox type={alert.type} message={alert.message} children={alert.children} />
            </FormContentCard>
            <FormActions>
                <SNETButton color="primary" children="finish later" onClick={onFinishLater} />
                <SNETButton color="primary" children="back" onClick={handleBack} />
                <SNETButton
                    color="primary"
                    variant="contained"
                    children="continue"
                    disabled={isDisableContinueButton}
                    onClick={handleContinue}
                />
            </FormActions>
        </Fragment>
    );
};

export default Region;
